import type { IAssetSource, ICache } from '@monofe/util';

export enum ITourType {
    Undef = 0,
    List = 1,
    Cascaded = 2,
    Keypad = 3,
    Hamburger = 4,
    LastValue = 5,
}

export interface ITextProps {
    text: string;
    fontFamily: string;
    fontSize: string;
    lineHeight: string;
    fontAlignment: 'left' | 'center' | 'right' | 'justify';
    fontWeight: number;
    color: string;
    visible: boolean;
}

export interface IImageProps {
    urls: IAssetSource[];
    mode: 'contain' | 'cover';
}

export interface IBackButtonProps {
    backgroundColor: string;
    strokeColor: string;
    strokeSize: string;
    arrowColor: string;
    visible: boolean;
}

export interface ITourSubItemViewModel {
    title: ITextProps;
    backgroundImage: IImageProps;
    backgroundColor: string;
    cornerRadius: number;

    shouldGrayAfterViewing: boolean;

    shouldLazyLoad: boolean;
    data?: unknown;

    onClick: string | ((item: ITourSubItemViewModel) => void);
}

export interface ITourItemViewModel {
    title: ITextProps;
    titleBackgroundColor: string;

    subtitle?: ITextProps;
    subtitleBackgroundColor?: string;

    backgroundImage: IImageProps;
    backgroundColor: string;
    cornerRadius: number;

    number: ITextProps;
    numberBackgroundColor: string;

    shouldGrayAfterViewing: boolean;

    cache?: ICache;
    subItems: ITourSubItemViewModel[];

    link?: string;

    onShow?: (item: ITourItemViewModel) => void;
    onClick?: (item: ITourItemViewModel) => void;
}

export interface ITourTopBarProps {
    title: ITextProps;
    backgroundColor: string;
    iconColor: string;
}

export interface ITourSideMenuViewProps {
    backgroundColor: string;
    foregroundImage: IImageProps;
    items: ITourSideMenuItemViewProps[];
}

export interface ITourSideMenuItemViewProps {
    title: ITextProps;
    backgroundColor: string;

    onClick: string | ((item: ITourSideMenuItemViewProps) => void);
}

export interface ITourCollectionViewProps {
    backgroundColor: string;
    backgroundImage: IImageProps;

    items: ITourItemViewModel[];
}

export interface ITourMainProps {
    backgroundColor: string;
    backgroundImage: IImageProps;

    backButton: IBackButtonProps;

    collection: ITourCollectionViewProps;

    sideMenu: ITourSideMenuViewProps;
    topBar: ITourTopBarProps;
    showFloorPlanIcon: boolean;
    hasContentDownloaded: boolean;

    onDownloadStatusRequest?: (shouldDownload: boolean) => void;
    onBack?: () => void;

    onFloorPlanSelect?: () => void;
    floorplanHref?: string;
    onScroll?: (position: { scrollTop: number; scrollLeft: number }) => void;
}

export interface ITourItemProps {
    model: ITourItemViewModel;
    isExpanded: boolean;

    onClick?: (model: ITourItemProps) => void;
}

export interface ITourSubItemProps {
    model: ITourSubItemViewModel;
    isSelected: boolean;

    onHighlight?: () => void;
    onUnhighlight?: () => void;
    onClick?: () => void;
}

export interface ITourIndexProps {
    model: ITourMainProps;
    type: ITourType;
}

export type ITourStateActionModifier = (model: ITourMainProps) => ITourMainProps;
